import { FunctionComponent, ReactNode } from 'react';
import { Div, Gutter } from '@gaiads/telia-react-component-library';
import { useToBreakpoint } from '@cdaas/reusable-components-daas';

import Header from '../../Components/Layout/Header/Header';
import ShopFooter from '../../Components/Layout/Footer/Footer';
import { WrappedOrganizationSelector } from '../../Components/OrganizationSelector/OrganizationSelector';

import classes from './NavigationLayout.module.scss';

interface NavigationLayoutProps {
  children?: ReactNode;
}

const NavigationLayout: FunctionComponent<NavigationLayoutProps> = ({ children }) => {
  const isMobile = useToBreakpoint(600);

  return (
    <>
      {!isMobile && <WrappedOrganizationSelector position={'top'} />}
      <Header />
      {isMobile && <WrappedOrganizationSelector position={'bottom'} />}
      <div style={{ borderTop: '1px solid var(--gaia-color-gray-300)', width: '100vw' }} />
      <Div className={classes['base-container']} occupyHorizontalSpace>
        {children}
      </Div>
      <Gutter size="layout-7" />
      <ShopFooter />
    </>
  );
};

export default NavigationLayout;
